import { useQuery } from '@tanstack/react-query';
import type { Dashboard } from '@sirajoptic/shared';
import { api } from '@/lib/api-client';

export const cleDashboard = ['dashboard'] as const;

/** Un seul appel alimente tout l'écran d'accueil. */
export function useDashboard() {
  return useQuery({
    queryKey: cleDashboard,
    queryFn: () => api.get<Dashboard>('/dashboard'),
    staleTime: 60_000,
  });
}
